import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from './reducer';
import { selectCabinetDomain } from 'containers/Configurator/selectors/furniture';

/**
 * Direct selector to the furniturePanel state domain
 */

export const selectFurniturePanelDomain = (state: ApplicationRootState) => {
  return state.furniturePanel || initialState;
};

/**
 * Other specific selectors
 */

/**
 * Default selector used by FurniturePanel
 */

export const makeSelectDisplayFurniturePanel = () =>
  createSelector(selectCabinetDomain, substate => substate.selectedId === null);
